module.exports = __webpack_public_path__ + "img/327.0b55dc26.jpg";